import React, { useState } from 'react';
import { Modal } from 'components/Modal';
import { request } from 'helpers/tools';
import { NavSelect } from 'components/NavSelect';
import styles from 'css_modules/NotificationModal.module.css';
import { ReactComponent as CancelIcon } from 'assets/svg/2_cancel.svg';

export const NotificationModal = ({ user, clickedClose }) => {
    const [notifications, setNotifications] = useState(
        user.data.notifications || []
    );

    const hasUnread = notifications.some(n => !n.is_read);
    const [showUnreadOnly, setShowUnreadOnly] = useState(hasUnread);

    const visibleNotifications = showUnreadOnly
        ? notifications.filter(n => !n.is_read)
        : notifications;

    const roleTranslations = {
        clientuser: 'Základní uživatel',
        maintenanceuser: 'Obslužný uživatel',
        managementuser: 'Schvalovací uživatel',
        accountantuser: 'Účetní uživatel',
    };

    const translateRole = (role) => {
        if (!role) return null;
        const key = role.toLowerCase().replace(/\s+/g, '');
        return roleTranslations[key] || role;
    };

    const handleDismiss = async (id) => {
        const updated = notifications.filter(n => n.id !== id);
        setNotifications(updated);
        user.data.notifications = updated;

        await request('/set_user_notifications/', 'POST', JSON.stringify({
            notifications: updated.map(n => ({ ...n, is_read: true }))
        }));

        if (updated.length === 0) clickedClose();
    };

    const handleClose = async () => {
        if (notifications.length) {
            const payload = notifications.map(n => ({ ...n, is_read: true }));
            user.data.notifications = payload;

            await request(
                '/set_user_notifications/',
                'POST',
                JSON.stringify({ notifications: payload })
            );
        }
        clickedClose();
    };

    const handleDeleteAll = async () => {
        setNotifications([]);
        user.data.notifications = [];

        await request(
            '/set_user_notifications/',
            'POST',
            JSON.stringify({ notifications: [] })
        );

        clickedClose();
    };

    const onRoleChange = async (role) => {
        await request('/user/role/', 'POST', role).catch(() => {});
    };

    if (!visibleNotifications.length) return null;

    return (
        <div className={styles.ontop}>
            <Modal name="Upozornění" close={handleClose}>
                {hasUnread && (
                        <div className={styles.filter}>
                            <label>Zobrazit</label>

                            <NavSelect
                                data={[
                                    { id: 'all', title: 'Vše' },
                                    { id: 'unread', title: 'Jen nepřečtené' },
                                ]}
                                value={showUnreadOnly ? 'unread' : 'all'}
                                onChange={(e) =>
                                    setShowUnreadOnly(e.target.value === 'unread')
                                }
                                inputClass={styles.navSelect}
                                border
                            />
                        </div>
                    )}
                <main className={styles.body}>

                    

                    {visibleNotifications
                        .slice()
                        .reverse()
                        .map((n) => {
                            const uuid =
                                n.docuuid ||
                                n.message.match(/"([^"]+)"/)?.[1];

                            const translatedRole = translateRole(n.role);

                            return (
                                <div
                                    key={n.id}
                                    className={`${styles.row} ${n.is_read ? styles.read : styles.unread}`}
                                    onClick={async () => {
                                        if (!uuid) return;

                                        let roleToSend = n.role;
                                        if (
                                            roleToSend &&
                                            roleToSend.toLowerCase() === 'managementuser' &&
                                            n.management_level
                                        ) {
                                            roleToSend += n.management_level;
                                        }

                                        if (roleToSend) {
                                            await onRoleChange(roleToSend);
                                        }

                                        await handleClose();
                                        window.location.assign(
                                            `/my_documents/${uuid}/general`
                                        );
                                    }}
                                >
                                    <CancelIcon
                                        className={styles.close}
                                        title="Smazat upozornění"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleDismiss(n.id);
                                        }}
                                    />

                                    {(translatedRole || n.management_level) && (
                                        <div className={styles.role}>
                                            {translatedRole}
                                            {n.management_level && (
                                                <> (Úr. {n.management_level})</>
                                            )}
                                        </div>
                                    )}

                                    <div className={styles.date}>
                                        {new Date(n.created_at).toLocaleDateString('cs-CZ')}{' '}
                                        {new Date(n.created_at).toLocaleTimeString('cs-CZ', {
                                            hour: '2-digit',
                                            minute: '2-digit',
                                        })}
                                    </div>

                                    <div className={styles.message}>
                                        {n.message}
                                    </div>
                                </div>
                            );
                        })}

                    

                </main>
                {/* footer */}
                    <div className={styles.footer}>
                        <button
                            className={styles.deleteAll}
                            onClick={handleDeleteAll}
                        >
                            Smazat vše
                        </button>
                    </div>
            </Modal>
        </div>
    );
};
